import { BLOCKS } from '@contentful/rich-text-types'
import type { GatsbyColoredSectionSchema } from '@ecomm/shared-sections'

export const confidenceBannerMock =
  async (): Promise<GatsbyColoredSectionSchema> =>
    await {
      __typename: 'ContentfulColoredSection',
      contentful_id: 'contentful-id'
    }

export const apolloConfidenceBannerMock = {
  headline: 'Say yes with confidence',
  contentCollection: {
    items: [
      {
        text: {
          json: {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'transparent',
                    nodeType: 'text'
                  }
                ],
                nodeType: BLOCKS.PARAGRAPH
              }
            ],
            nodeType: BLOCKS.DOCUMENT
          }
        }
      },
      {
        text: {
          json: {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'simple',
                    nodeType: 'text'
                  }
                ],
                nodeType: BLOCKS.PARAGRAPH
              }
            ],
            nodeType: BLOCKS.DOCUMENT
          }
        }
      },
      {
        text: {
          json: {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'fair',
                    nodeType: 'text'
                  }
                ],
                nodeType: BLOCKS.PARAGRAPH
              }
            ],
            nodeType: BLOCKS.DOCUMENT
          }
        }
      }
    ]
  },
  disclaimer: {
    json: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'disclaimer',
              nodeType: 'text'
            }
          ],
          nodeType: BLOCKS.PARAGRAPH
        }
      ],
      nodeType: BLOCKS.DOCUMENT
    }
  }
}
